declare namespace $ {

	export class $mol_icon_paperclip extends $mol_icon {
		path( ): string
	}
	
}

//# sourceMappingURL=paperclip.view.tree.d.ts.map